var map = {
	"./config.png": "b214",
	"./contents.png": "2ae0",
	"./customers.png": "efee",
	"./home.png": "3cff",
	"./maintenance.png": "a95d",
	"./statistics.png": "c61b",
	"./support.png": "070b",
	"./treatments.png": "a744",
	"./users.png": "c7fb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3629";